import React from 'react';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { ProductPresentation } from './components/ProductPresentation';
import { PackSection } from './components/PackSection';
import { BenefitsSection } from './components/BenefitsSection';
import { DiferencialSection } from './components/DiferencialSection';
import { ReviewsSection } from './components/ReviewsSection';
import { PricingSection } from './components/PricingSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { ClosingSection } from './components/ClosingSection';
import { PurchaseNotification } from './components/PurchaseNotification';
export function App() {
  return <div className="w-full min-h-screen bg-motor-black" data-id="element-0">
      <Hero data-id="element-1" />
      <ProblemSection data-id="element-2" />
      <ProductPresentation data-id="element-3" />
      <PackSection data-id="element-4" />
      <BenefitsSection data-id="element-5" />
      <DiferencialSection data-id="element-6" />
      <ReviewsSection data-id="element-7" />
      <PricingSection data-id="element-8" />
      <GuaranteeSection data-id="element-9" />
      <ClosingSection data-id="element-10" />
      <PurchaseNotification data-id="element-11" />
    </div>;
}